export default function (axios, config) {
  const importMap = function (row) {
    return {
      id: row.id,
      date: row.field_datum,
      text: row.field_notiz
    }
  }

  return {
    invalidate () {
      this.getAll.invalidate()
      this.getOne.invalidate()
    },
    getAll: config.cachedFunction(async function (colony) {
      const response = await axios({
        url: config.serverUrl + '/api/node/' + colony + '?_format=json',
        method: 'get',
        withCredentials: true
      })

      const colonyData = Object.values(response.data.result)[0]

      if (!colonyData || !colonyData.field_massnahmen_und_aktionen) return []

      return Object.values(colonyData.field_massnahmen_und_aktionen)
        .filter(function (row) {
          return row.type === 'notiz'
        })
        .map(function (row) {
          return importMap(row)
        })
        .sort(function (rowA, rowB) {
          if (rowA.date < rowB.date) {
            return 1
          }
          if (rowA.date > rowB.date) {
            return -1
          }

          return 0
        })
    }),
    getOne: config.cachedFunction(async function (id) {
      const response = await axios({
        url: config.serverUrl + '/api/paragraph/' + id + '?_format=json',
        method: 'get',
        withCredentials: true
      })

      if (!response.data.result) return null

      const row = Object.values(response.data.result)[0]
      return importMap(row)
    }),
    async save ({ id, colony, date, token, text }) {
      this.invalidate()
      const data = {
        field_datum: date,
        type: 'notiz',
        field_notiz: text
      }

      const url = (id ? config.serverUrl + '/api/paragraph/' + id + '?_format=json' : config.serverUrl + '/api/node/' + colony + '?_format=json')

      const noteResult = await axios({
        url,
        method: 'patch',
        data: (id ? data : {
          field_massnahmen_und_aktionen: [data]
        }),
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })

      const note = Object.values(noteResult.data.result)[0]

      if (id) {
        // patch colony to reset Drupal-cache
        await axios({
          url: config.serverUrl + '/api/node/' + colony + '?_format=json',
          method: 'patch',
          data: {},
          withCredentials: true,
          headers: {
            'X-CSRF-Token': token
          }
        })
      }

      return note
    },
    async delete ({ id, colony, token }) {
      this.invalidate()
      const url = (id ? config.serverUrl + '/api/paragraph/' + id + '?_format=json' : config.serverUrl + '/api/node/' + colony + '?_format=json')

      const noteResult = await axios({
        url,
        method: 'delete',
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })
      const note = Object.values(noteResult)

      if (id) {
        // patch colony to reset Drupal-cache
        await axios({
          url: config.serverUrl + '/api/node/' + colony + '?_format=json',
          method: 'patch',
          data: {},
          withCredentials: true,
          headers: {
            'X-CSRF-Token': token
          }
        })
      }

      return note
    }
  }
}
